class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);

(function () {
  function blockCheckoutIfNeeded(event) {
    const form = event.target;
    if (!form || form.tagName !== 'FORM') return;

    const submitter = event.submitter;
    if (!submitter) return;

    // Nur Checkout-Submit blockieren (nicht "update", nicht qty-change)
    const isCheckout =
      submitter.name === 'checkout' ||
      submitter.getAttribute('name') === 'checkout' ||
      submitter.matches('[name="checkout"]');

    if (!isCheckout) return;

    const checkbox = form.querySelector('#campingbox_notice');
    const errorEl = form.querySelector('#campingbox_notice_error');

    const dealerCheckbox = form.querySelector('#haendler_agb_accept');
    const dealerErrorEl = form.querySelector('#haendler_agb_error');

    let hasError = false;
    let firstInvalidElement = null;

    if (checkbox && !checkbox.checked) {
      hasError = true;
      if (!firstInvalidElement) firstInvalidElement = checkbox;
      if (errorEl) errorEl.style.display = 'block';
    } else {
      if (errorEl) errorEl.style.display = 'none';
    }

    if (dealerCheckbox && !dealerCheckbox.checked) {
      hasError = true;
      if (!firstInvalidElement) firstInvalidElement = dealerCheckbox;
      if (dealerErrorEl) dealerErrorEl.style.display = 'block';
    } else {
      if (dealerErrorEl) dealerErrorEl.style.display = 'none';
    }

    if (hasError) {
      event.preventDefault();
      event.stopPropagation();

      try {
        firstInvalidElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (e) {}

      return;
    }
  }

  // Capture-Phase, damit Theme-Handler nicht vorher "durchrutschen"
  document.addEventListener('submit', blockCheckoutIfNeeded, true);

  // Fehler ausblenden, sobald angehakt
  document.addEventListener('change', function (e) {
    if (e.target && e.target.id === 'campingbox_notice') {
      const form = e.target.closest('form');
      const errorEl = form ? form.querySelector('#campingbox_notice_error') : null;
      if (errorEl) errorEl.style.display = e.target.checked ? 'none' : 'block';
    }

    if (e.target && e.target.id === 'haendler_agb_accept') {
      const form = e.target.closest('form');
      const errorEl = form ? form.querySelector('#haendler_agb_error') : null;
      if (errorEl) errorEl.style.display = e.target.checked ? 'none' : 'block';
    }
  }, true);
})();